export default __webpack_public_path__ + "static/media/027-protective wear.5646c3d1.svg";